import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap, SoloLoading } from '../../components';
import DailyTipForm from './DailyTipForm';
import { useParams } from 'react-router';
import { Api } from '../../api';

export default function EditDailyTipScreen() {
  const { weekNumber, weekId, id } = useParams();

  const api = Api.DailyTip.useReadItem(id ?? '');

  if (!api.data) return <SoloLoading />;

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Edit Daily Tip"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/daily-tips`,
            },
          ]}
        />
        <DailyTipForm existing={api.data} />
      </Stack>
    </ScreenWrap>
  );
}
